<div class="flash-form-container">
  <div class="action-container">
    <p class="flash-label">Por favor, verifica tu pago para continuar.</p>
  </div>

   <app-ach-summary></app-ach-summary>

   <app-card-summary></app-card-summary>
</div>
